<template>
	<div class="p-grid p-pb-6 recipe-editing">
		<div class="p-col-12 p-pt-1 p-pb-1">
      <Header 
        :serialNumber="serialNumber" 
        :applianceName="(serialNumber && appliance ? (appliance.name ?? $functions.fixModelName(appliance.modelNumber)) : null)"
        :recipeId="recipeId"
        :recipeName="recipeName"
        :step="step"
        :buttonHidden="headerButtonHidden"
        @click:button="next"
        @update:step="updateStep"
      ></Header>

      <!-- STEP 1 - FASI -->
      <div v-if="(step===1 && recipe)" class="p-mt-2 p-mb-2">

        <Carousel :recipe="recipe" :editing="true"
          :editingControls="editingControls"
          @remove:phase="removePhase"
          @add:phase="addPhase"
          @select:phase="editPhase"
          />

        <div v-if="editingControls" class="cycle-controls p-mt-4">

          <Setpoints :recipe="recipe" :currentSlide="currentSlide" @update:setpoints="updateSetpoints"/>

          <div class="p-text-right p-mt-4">
            <Button :label="$t('library.steps.phases.edit_phase_cancel')" 
              class="p-button-outlined p-mr-3"
              @click="() => { editingControls = false; headerButtonHidden = false; }" />
            <Button :label="$t('library.steps.phases.edit_phase_confirm')" 
              @click="updatePhase" />
          </div>

        </div>

      </div>
      
      <!-- STEP 2 - ICONA COLORE -->
      <div v-if="(step===2)">
        <IconColor 
          :image="recipe.image"
          :color="recipe.color"
          @update:image="updateRecipe"
          @update:color="updateRecipe"
          @update:headerButtonHidden="(hide) => {headerButtonHidden=hide}"
        ></IconColor>
      </div>
      
      <!-- STEP 3 - INFO -->
      <div v-if="(step===3)">
        <Info 
          :name="recipe.name"
          :description="recipe.description"
          @update:name="updateRecipe"
          @update:description="updateRecipe"
          @update:headerButtonHidden="(hide) => {headerButtonHidden=hide}"
        ></Info>
      </div>

		</div>

    <!--                    -->
    <!-- ERRORS and SUCCESS -->
    <!--                    -->
    <IrinoxDialogDark :visible="dialog.error" 
      mode="error" 
      :message="$t('library.dialog_error')"
      :life="3000" 
      @update:visible="dialog.error = $event" />

    <Dialog :visible="dialog.save" class="irinox-dialog-dark" :modal="true" 
            :closable="false" :dismissableMask="true" :style="{width: '580px'}" :draggable="false"
            @update:visible="updateVisible">
    
      <div class="irinox-dialog-dark-content">
        <img src="assets/irinox/icons/save_big.svg" width="80" :alt="$t('common.save')"/>
        <div class="p-pt-3 p-pb-3">{{!recipeId ? $t('library.steps.info.save_edit_cycle_dialog_new') : $t('library.steps.info.save_edit_cycle_dialog_mod')}}</div>
        <!-- NUOVA RICETTA -->
        <div v-if="!recipeId">
          <Button :label="$t('library.steps.info.save_edit_cycle_dialog_cancel')" @click="() => { dialog.save = false; }"/>
          <Button :label="$t('library.steps.info.save_edit_cycle_dialog_create')" class="p-button-secondary" @click="saveCreateNew"/>
        </div>
        <!-- RICETTA IRINOX MODIFICATA -->
        <div v-else-if="isIrinoxRecipe">
          <Button :label="$t('library.steps.info.save_edit_cycle_dialog_cancel')" @click="() => { dialog.save = false; }"/>
          <Button :label="$t('library.steps.info.save_edit_cycle_dialog_copy')" class="p-button-secondary" @click="saveCreateNew"/>
        </div>
        <!-- RICETTA CUSTOM MODIFICATA -->
        <div v-else class="more-than-2-buttons"> 
          <Button :label="$t('library.steps.info.save_edit_cycle_dialog_cancel')" @click="() => { dialog.save = false; }"/>
          <Button :label="$t('library.steps.info.save_edit_cycle_dialog_overwrite')" class="p-button-secondary" @click="saveOverwrite"/>
          <Button :label="$t('library.steps.info.save_edit_cycle_dialog_copy')" class="p-button-secondary" @click="saveCreateNew"/>
        </div>
      </div>

      <template #footer>
      </template>
    </Dialog>

    <IrinoxDialogDark :visible="dialog.saveCreateSuccess" 
      mode="success" 
      :message="$t('library.steps.info.save_edit_cycle_dialog_created')"
      :life="3000" 
      @update:visible="dialog.saveCreateSuccess = $event" />
    <IrinoxDialogDark :visible="dialog.saveOverwriteSuccess" 
      mode="success" 
      :message="$t('library.steps.info.save_edit_cycle_dialog_overwrited')"
      :life="3000" 
      @update:visible="dialog.saveOverwriteSuccess = $event" />

    <NonStopTempSelect v-if="!recipeId && recipe && recipe.function===13" :visible="dialog.nonStopTemperature" 
        @select:temperature="nonStopTemperatureSelected"></NonStopTempSelect>
    

	</div>
</template>

<script>
import RecipeService from '../../../service/RecipeService';
import AccountService from '../../../service/AccountService';
import { mapGetters } from 'vuex';
import defaults from "../../../../public/json/cycles_mf.json";
import commands from "../../../../public/json/commands_mf.json";
import Header from "./Header.vue";
import IconColor from "./IconColor.vue";
import Info from "./Info.vue";
import Carousel from '../overview/mf/Carousel.vue';
import IrinoxDialogDark from '../../IrinoxDialogDark.vue';
import Setpoints from './Setpoints.vue';
import NonStopTempSelect from './NonStopTempSelect.vue';

export default {

  components: {
      Header,
      IconColor,
      Info,
      Carousel,
      IrinoxDialogDark,
      Setpoints,
      NonStopTempSelect,
    },
    data() {
        return {
          commands: commands,
          serialNumber: this.$route.params.serialNumber,
          function: this.$route.params.function,
          recipeId: this.$route.params.recipeId,
          recipe: null,
          recipeName: null,
          defaults: defaults,
          step: 1,
          headerButtonHidden: false,
          editingControls: false,
          // company: null,
          sectorMappings: {
            gastronomy: 1,
            pastry: 2,
            bakery: 4,
            icecream: 8
          },
          dialog: {
            error: false,
            save: false,
            saveCreateSuccess: false,
            saveOverwriteSuccess: false,
            nonStopTemperature: true
          },
          currentSlide: -1,
          setpoints: {},
        };
    },
    computed: {
      ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          isCelsius: 'userdata/isCelsius',
          // storedRecipe: 'library/recipe'
        }),
        appliance: function() {
            return this.serialNumber ? this.$store.getters['appliances/appliance'](this.serialNumber) : null;
        },
        limits() {
          return this.commands.functions[this.recipe.function];
        },
        isIrinoxRecipe() {
          return this.recipe.type === 0;
        },
    },
    created() {
      this.recipeService = new RecipeService();
      this.accountService = new AccountService();
    },
    mounted() {
      this.currentSlide = -1;
      this.recipeName = null;
      if(!this.recipeId) {
        let func = this.defaults.functions[this.function];
        if(!func) {
          this.dialog.error = true;
          setTimeout(function() {
            this.$functions.historyBack();
          }.bind(this), 3000);
        } else {
          this.recipe = {
            type: 1,
            package: ["3","4","5","6","7","8","9","10","11","12"].includes(this.function) ? 7 : (this.function == "15" ? 8 : 1),
            name: "",
            description: "",
            help: "",
            color: -1,
            image: -1,
            function: Number(this.function),
            temperature: 0,
            sector: 15,
            num_phases: 0,
            phases: this.$functions.clone(func.defaultPhases)
          };
          // this.accountService.getCompany(this.personaltoken)
          //   .then(company => {
          //     this.company = company;
          //   })
          //   .catch(error => {
          //     console.error("EXCEPTION "+error);
          //   });
        }
      } else {
        this.recipeService.getRecipeDetails(this.personaltoken, this.recipeId, this.serialNumber)
          .then((data) => {
            this.recipe = data.body;
            this.recipeName = (this.recipe ? this.recipe.name : '');
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.recipe = null;
            this.dialog.error = true;
            setTimeout(function() {
              this.$functions.historyBack();
            }.bind(this), 3000);
          });
      }
    },
    watch: {
      // storedRecipe: 'updateTemporaryRecipe',
      // step: 'updateTemporaryRecipe'
    },
    methods: {
      // updateTemporaryRecipe() {
      //   this.recipe = this.$functions.clone(this.storedRecipe);
      // },
      next() {
        // this.$store.commit('library/recipe', this.recipe);
        if(this.step==1 || this.step==2) {
          this.step++;
        } else if(this.step==3) {
          this.dialog.save = true;
        }
      },
      updateStep(newStep) {
        this.step = newStep;
      },
      updateRecipe(updatedData) {
        this.recipe = {...this.recipe, ...updatedData};
      },
      removePhase(index) {
        this.recipe.phases.splice(index, 1);
      },
      addPhase(newPhase) {
        let phaseLimit = this.limits.phases[newPhase.type];
        let p = {
          type: newPhase.type,
          notification_type: 0,
          notification_value: 0,
          set_temp_room: phaseLimit.cellSetTempMin,
          set_temp_probe: phaseLimit.coreProbeSetTempMin,
          set_ventilation: phaseLimit.evapFanSetSpeedMin,
          set_duration: phaseLimit.phaseDurationSetMin*60,
          set_humidity: 0
        };
        this.recipe.phases.splice(newPhase.position, 0, p);
      },
      editPhase(index) {
        this.currentSlide = index;
        this.headerButtonHidden = true;
        this.editingControls = true;
      },
      updatePhase() {
        let p = this.recipe.phases[this.currentSlide];
        p.set_temp_room = this.setpoints.temperature/10;
        p.set_temp_probe = this.setpoints.core/10;
        p.set_ventilation = this.setpoints.fan;
        p.set_duration = this.setpoints.time*60;
        this.editingControls = false; 
        this.headerButtonHidden = false;
      },
      updateVisible(value) {
        if(!value) {
          this.dialog.save = false;
        }
      },
      saveCreateNew() {
        let tmpRecipe = this.fillNewRecipe();
        console.log("SAVING NEW... "+JSON.stringify(tmpRecipe));
        this.saveRecipe(tmpRecipe, false);
      },
      saveOverwrite() {
        this.recipe.num_phases = this.recipe.phases.length;
        this.recipe.temperature = this.recipe.phases[this.recipe.phases.length-1].set_temp_room;
        console.log("OVERWRITING... "+JSON.stringify(this.recipe));
        this.saveRecipe(this.recipe, true);
      },
      saveRecipe(recipeToSave, overwrite) {
        this.dialog.save = false;
        this.recipeService.saveRecipe(this.personaltoken, recipeToSave, overwrite ? this.recipeId : null)
          .then((data) => {
            if(data.code=="200") {
              if(this.serialNumber) {
                console.log("SAVE RESULT "+JSON.stringify(data.body));
                this.shareRecipe(data.body, overwrite);
              } else {
                if(overwrite) {
                  this.dialog.saveOverwriteSuccess = true;
                } else {
                  this.dialog.saveCreateSuccess = true;
                }
                this.exit();
              }
            } else {
              console.error("SAVE ERROR "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("SAVE ERROR "+error);
            this.dialog.error = true;
          });
      },
      shareRecipe(newRecipeId, overwrite) {
        this.recipeService.shareRecipe(this.personaltoken, newRecipeId, this.serialNumber)
          .then((data) => {
            console.log("SHARE RESULT "+JSON.stringify(data));
            if(overwrite) {
              this.dialog.saveOverwriteSuccess = true;
            } else {
              this.dialog.saveCreateSuccess = true;
            }
            this.exit();
          })
          .catch(error => {
            console.error("SHARE ERROR "+error);
            this.exit();
          });
      },
      exit() {
        setTimeout(function() {
          if(this.serialNumber) {
            this.$router.push({ name: 'appliance-library', params: { serialNumber: this.serialNumber } });
          } else {
            this.$router.push({ name: 'library' });
          }
        }.bind(this),3000);
      },
      fillNewRecipe() {
        // let tmpSector = this.company && this.company.sector ? this.sectorMappings[this.company.sector] : null
        return {
          type: 1,
          package: this.recipe.package,
          name: this.recipe.name,
          description: this.recipe.description,
          help: this.recipe.help,
          color: this.recipe.color,
          image: this.recipe.image,
          function: this.recipe.function,
          temperature: this.recipe.phases[this.recipe.phases.length-1].set_temp_room,
          // sector: this.recipe.sector ?? (tmpSector ?? 0),
          sector: this.recipe.sector ?? 15,
          num_phases: this.recipe.phases.length,
          phases: this.recipe.phases
        };
      },
      updateSetpoints(newSetpoints) {
        this.setpoints = newSetpoints;        
      },
      nonStopTemperatureSelected(newTemperature) {
        this.recipe.phases[0].set_temp_room = newTemperature;
        this.dialog.nonStopTemperature = false;
      }
    },

}
</script>

<style scoped>
</style>